import axios from "utils/axios";

// Aggregate view of the HLS conversion queue (backend/modules/hls_queue.py +
// modules/models.py::HlsConversionJob) — feeds the global conversion-queue
// panel (contexts/HlsJobsContext.jsx). Mirrors the single-entity
// conversion-status helpers in api/admin/formation.js.
export const getHlsJobs = async () => {
  const { data } = await axios.get(`/api/modules/admin/hls-jobs/`);
  return data?.jobs || [];
};
